import { combineReducers } from "@reduxjs/toolkit";
import navbar from "./navbarSlice";

const ui = combineReducers({
  navbar,
});

export default ui;
